const CATALOG_FRAGMENT_TYPE = "catalog";

const getFragmentScope = (type?: string): string | undefined =>
	type && type !== CATALOG_FRAGMENT_TYPE ? type : undefined;

export default getFragmentScope;
